import { GetRequest, PutRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"
import { ERequestType } from "../../Enum/ERequestType"
import { CourierEntity } from "../../Objects/Courier/CourierEntity"
import { ECourierVehicleType } from "../../Enum/ECourierVehicleType"

export const useCourierAccount = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const wrap = async (callback: () => Promise<void>) => {
    try {
      enableLoad()

      await callback()
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleUpdateProfile = async (
    payload: { name: string; phone: string; vehicleType: ECourierVehicleType },
    onSuccess?: (courier: CourierEntity) => void,
  ) =>
    wrap(async () => {
      const response = await PutRequest<CourierEntity>(
        API_ROUTES.DELIVERY.UPDATE_COURIER_PROFILE,
        payload,
        ERequestType.Courier,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess && onSuccess(new CourierEntity(response.data))
    })

  const handleChangePassword = async (
    payload: { currentPassword: string; newPassword: string },
    onSuccess?: () => void,
  ) =>
    wrap(async () => {
      const response = await PutRequest<boolean>(
        API_ROUTES.DELIVERY.UPDATE_COURIER_PASSWORD,
        payload,
        ERequestType.Courier,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess && onSuccess()
    })

  const handleGetCourierProfile = async (onSuccess?: (courier: CourierEntity) => void) =>
    wrap(async () => {
      const response = await GetRequest<CourierEntity>(API_ROUTES.DELIVERY.GET_COURIER_UPDATED, ERequestType.Courier)

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess && onSuccess(new CourierEntity(response.data))
    })

  return {
    handleUpdateProfile,
    handleChangePassword,
    handleGetCourierProfile,
  }
}
